<div class="status-wrap" *transloco="let transl">
  <img src="/assets/web/images/{{getIconForStatus()}}.svg" />
  <span>{{ transl(getStatus()) }}</span>

</div>
